/**
 * Mirrors the Payments.Backoffice `userEvents` contract (US-3391).
 * Backend DTOs: Payments.Core/Models/UserEventsReport.cs.
 */

import { UserCommunicationTimelineEntry } from './UserCommunicationHistoryTypes';

/** Mirrors `UserEventsRequest.DefaultPageSize`. */
export const USER_EVENTS_PAGE_SIZE = 25;

/**
 * Mirrors `UserEventsRequest.MaxPageSize`. The backend clamps to this, so it is also the largest
 * page size worth offering — and the reason there is no "All" option.
 */
export const USER_EVENTS_MAX_PAGE_SIZE = 200;

export interface UserEventTypeCount {
    eventType: string;
    count: number;
}

export interface UserEventsQueryParams {
    /** Event-type names to keep. Empty means no narrowing. */
    eventTypes: string[];
    limit: number;
    offset: number;
}

export interface UserEventsReport {
    userId: string;
    /** Operator-facing display name, or "Deleted user" for an erased user. */
    displayIdentity: string;
    /** True when no live User resolved (de-identified/erased per US-3248). */
    isDeletedUser: boolean;
    /** The requested page, newest first, with GetBalance polls already collapsed. */
    events: UserCommunicationTimelineEntry[];
    /** Rows matching the filter across the whole feed — the page count, not this page's size. */
    total: number;
    /** Row counts per event type across the whole feed, ignoring the filter. Drives the filter list. */
    eventTypeCounts: UserEventTypeCount[];
    /** How many GetBalance rows the 30s window folded away across the whole feed. */
    suppressedEventCount: number;
}
